import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5ecf4d6f")
const _hoisted_1 = { class: "filter-controll flex-box jc-c" }
const _hoisted_2 = { class: "post-time" }
const _hoisted_3 = { class: "controll-area flex-box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ri-send-plane-2-line ri-xl" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_box = _resolveComponent("select-box")!
  const _component_chat_msg_body = _resolveComponent("chat-msg-body")!
  const _component_card = _resolveComponent("card")!
  const _component_multiline_field = _resolveComponent("multiline-field")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(`chat-area ${_ctx.postUser}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_select_box, {
        options: _ctx.filterOption,
        selectedVal: _ctx.selectedFilterVal,
        "onUpdate:selectedVal": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedFilterVal = $event)),
        fontSize: "14px"
      }, null, 8, ["options", "selectedVal"])
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(`messages ${_ctx.postUser}`),
      ref: "chatArea"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatList, (msgId) => {
        return (_openBlock(), _createElementBlock("li", { key: msgId }, [
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_chat_msg_body, {
                postUser: _ctx.msgObj[msgId]?.postUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.msgObj[msgId]?.body), 1)
                ]),
                _: 2
              }, 1032, ["postUser"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.convertDateToString(_ctx.msgObj[msgId]?.createdAt, 'hh:mm')), 1)
        ]))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_multiline_field, {
        inputVal: _ctx.chatTxt,
        "onUpdate:inputVal": _cache[1] || (_cache[1] = ($event: any) => (_ctx.chatTxt = $event)),
        placeholder: _ctx.chatPlaceHolder,
        onKeydown: [
          _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.sendMessage()), ["ctrl"]), ["enter"])),
          _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.sendMessage()), ["meta"]), ["enter"]))
        ]
      }, null, 8, ["inputVal", "placeholder"]),
      _createVNode(_component_custom_button, {
        type: "round",
        width: 44,
        height: 44,
        centering: true,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendMessage()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ], 2))
}